


































import {Component, PropSync, Watch} from 'vue-property-decorator';
import {Action, Getter} from "vuex-class";
import BaseFilter from "@/components/Filter/BaseFilter";
import {BlacklistContactsFilter} from "@/store/blacklists/types";
import {FilterWings, SelectWings, FilterSelectedItemWings, InputWings} from "wings-ui-components";
import {notifyError, notifyWarning} from "@/utils/notify-helper";
import { getTranslatedParams } from '@/utils/notify-utils';

@Component({components: {FilterSelectedItemWings, SelectWings, FilterWings, InputWings}})
export default class BlackListContactsFilter extends BaseFilter<BlacklistContactsFilter> {
  @PropSync('show') is_show!: boolean;
  @PropSync("filterClone") propFilterClone!: any;
  @PropSync("runFilter") propRunFilter!: boolean;
  @Getter("blacklistItem") blacklistItem: any;
  @Action("getBlackListContacts") actionGetBlackListContacts: any;
  @Action("actionLog") actionLog: any;

  defaultFilter(): BlacklistContactsFilter {
    return new BlacklistContactsFilter(this.$route.params.id)
  }

  created() {
    this.filter.blackListId = this.$route.params.id
    this.filtered();
    this.scroll();
  }

  async onFilteredAction(nextPage = false) {
    if (!nextPage) this.filter.page_number = 1;
    try {
      this.logObject = {
        actionPage: this.$route.meta.msgKey,
        action: "Viewing",
        actionStatus: 'success',
        objectType: "Contact",
        addititionalInfo: getTranslatedParams({...this.filter, blackListId: this.blacklistItem?.name})
      }
      const resp = await this.actionGetBlackListContacts(this.filter);
      if (resp.data?.contacts?.length == 0) {
        if (!nextPage) notifyWarning()
        this.is_last = true
      } else {
        this.is_last = false
      }
      await this.actionLog(this.logObject)
    } catch(error) {
      notifyError(error);
      await this.actionLog({...this.logObject, actionStatus: 'failed'})
    } finally {
      this.moreLoading = false;
    }
  }

  @Watch('filter', {immediate: true, deep: true})
  onFilterChange(val: any) {
    this.propFilterClone = val;
  }

  @Watch('propRunFilter', {immediate: true})
  onRunFilterChange(val: boolean) {
    if (val) {
      this.filtered();
      this.propRunFilter = false;
    }
  }

}
